import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../lib/api';

const BrandingContext = createContext();

export function useBranding() {
    const context = useContext(BrandingContext);
    if (!context) {
        throw new Error('useBranding must be used within BrandingProvider');
    }
    return context;
}

export function BrandingProvider({ children }) {
    const [branding, setBranding] = useState({
        app_title: 'Dashboard Monitor SSL',
        app_subtitle: 'Sistem monitoring sertifikat SSL',
        org_name: 'Universitas Muslim Indonesia',
        header_text: 'Monitor SSL',
        logo_url: null,
    });
    const [loading, setLoading] = useState(true);

    const loadBranding = async () => {
        try {
            const response = await settingsAPI.getBrandingConfig();
            setBranding(response.data);
        } catch (error) {
            console.error('Failed to load branding config:', error);
            // Keep default values on error
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadBranding();
    }, []);

    const refreshBranding = () => {
        return loadBranding();
    };

    return (
        <BrandingContext.Provider value={{ branding, loading, refreshBranding }}>
            {children}
        </BrandingContext.Provider>
    );
}
